import {
  IsNotEmpty,
  IsUUID,
  IsString,
  IsOptional,
  IsBoolean,
} from 'class-validator';

export class AddRoleCompanyDto {
  @IsUUID()
  companyId: string;

  @IsString()
  @IsNotEmpty({
    message: 'Вы забыли ввести название роли',
    groups: ['submit'],
  })
  roleName: string;

  @IsUUID()
  @IsOptional()
  parentRoleId?: string;

  @IsNotEmpty()
  @IsBoolean()
  allCompanies: boolean;
}
